import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { NotifProvider } from '@/common/notif/NotifContext';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AlertProvider } from './common/alert/AlertContext';
import { NavStateProvider } from './common/navState/NavStateContext';
import { PrincipalProvider } from './common/principal/PrincipalContext';
import { RsrcProvider } from './common/rsrc/RsrcContext';
import './index.css';
import { EntityChangeProvider } from '@/common/entityChange/EntityChangeContext';

// Setup for AgGrid
ModuleRegistry.registerModules([AllEnterpriseModule])
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-068532}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Kernel_Solutions_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{KERnal}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{KERnal}_need_to_be_licensed___{KERnal}_has_been_granted_a_Deployment_License_Add-on_for_{5}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_December_2025}____[v3]_[01]_MTc2NTE1MjAwMDAwMA==adc50dab642ffa54dbd78c7e317a65e0');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PrincipalProvider>
    <AlertProvider>
      <RsrcProvider>
        <NotifProvider>
          <BrowserRouter>
            <NavStateProvider>
              <EntityChangeProvider>
                <App />
              </EntityChangeProvider>
            </NavStateProvider>
          </BrowserRouter>
        </NotifProvider>
      </RsrcProvider>
    </AlertProvider>
  </PrincipalProvider>
);
